import qs from 'qs'
import request from '@/utils/request'

//登录方法
export const signIn = (data) => {
    return request.post('/admin_user/loginok.html',data)
}

//获取导航
export const getNavigation = (data) => {
  return request.post('/admin_user/getleftListC.html',data)
}

//角色管理
export const js_list = (data) => {
  return request.post('/admin_role/index.html',data)
}
//添加角色
export const js_add = (data) => {
  return request.post('/admin_role/add.html',data)
}
//角色详情
export const js_detail = (data) => {
  return request.post('/admin_role/detail.html',data)
}
//角色修改
export const js_edit = (data) => {
  return request.post('/admin_role/updata.html',data)
}
//角色启禁用
export const js_qi_jing = (data) => {
  return request.post('/admin_role/qy_jy.html',data)
}

//新增入库
export const newList = (data) => {
  return request.post('/caigou_index/add.html',data)
}

//获取名单列表
export const getList = (data) => {
  return request.post('/admin_mingdan/index.html',data)
}
//获取岗位类型
export const gangwei = (data) => {
  return request.post('/admin_mingdan/getGangwei.html',data)
}
//获取标签类型
export const getBQ = (data) => {
  return request.post('/admin_mingdan/getLabel.html',data)
}

//名单列表新增
export const getList_add = (data) => {
  return request.post('/admin_mingdan/addD.html',data)
}
//名单列表删除
export const getList_del = (data) => {
  return request.post('/admin_mingdan/del.html',data)
}
//名单列表评审
export const getList_ps = (data) => {
  return request.post('/admin_mingdan/getPFD.html',data)
}

//名单列表详情
export const getList_detal = (data) => {
  return request.post('/admin_mingdan/detailC.html',data)
}

//名单列表修改
export const getList_edit = (data) => {
  return request.post('/admin_mingdan/updataD.html',data)
}
//获取红名单列表
export const getHList = (data) => {
  return request.post('/admin_mingdan/indexRed.html',data)
}

//红名单重新评审
export const getHList_ps = (data) => {
  return request.post('/admin_mingdan/rePingsheD.html',data)
}

//统计列表
export const geTjList = (data) => {
  return request.post('/admin_tongji/index.html',data)
}

//点赞管理
export const getDZList = (data) => {
  return request.post('/admin_dianzan/index.html',data)
}

//岗位分类管理
export const getGwList = (data) => {
  return request.post('/admin_gangwei/index.html',data)
}

//岗位分类管理添加
export const getGwList_Add = (data) => {
  return request.post('/admin_gangwei/add.html',data)
}
//岗位分类管理修改
export const getGwList_Edit = (data) => {
  return request.post('/admin_gangwei/updata.html',data)
}
//岗位分类管理启用禁用
export const getGwList_qj = (data) => {
  return request.post('/admin_gangwei/qy_jy.html',data)
}
//标签管理
export const getBQList = (data) => {
  return request.post('/admin_label/index.html',data)
}

//标签管理添加
export const getBQList_Add = (data) => {
  return request.post('/admin_label/add.html',data)
}

//标签管理编辑
export const getBQList_Edit = (data) => {
  return request.post('/admin_label/updata.html',data)
}

//标签管理启用禁用
export const getBQList_qj = (data) => {
  return request.post('/admin_label/qy_jy.html',data)
}

//评价审核
export const getPJList = (data) => {
  return request.post('/admin_review/index.html',data)
}

//评价审核通过
export const getPJList_tg = (data) => {
  return request.post('/admin_review/agree.html',data)
}

//评价审核驳回
export const getPJList_bh = (data) => {
  return request.post('/admin_review/refuse.html',data)
}

//评价删除
export const getPJList_del = (data) => {
  return request.post('/admin_review/del.html',data)
}


//获取详情
export const openXq = (data) => {
  return request.post('/caigou_index/detail.html',data)
}
//修改入库内容
export const editRk = (data) => {
  return request.post('/caigou_index/updata.html',data)
}

//入库删除
export const RKDel = (data) => {
  return request.post('/caigou_index/del.html',data)
}

//进行出库
export const CkC = (data) => {
  return request.post('/caigou_index/chuku.html',data)
}
//用户列表
export const userInfo = (data) => {
  return request.post('/admin_user/index.html',data)
}
//获取用户角色
export const userInfo_js = (data) => {
  return request.post('/admin_user/allRole.html',data)
}

//添加用户
export const userAdd = (data) => {
  return request.post('/admin_user/add.html',data)
}

//用户详情
export const userXinXi = (data) => {
  return request.post('/admin_user/detail.html',data)
}

//修改用户
export const userEdit = (data) => {
  return request.post('/admin_user/updata.html',data)
}

//用户启用禁用
export const user_qj = (data) => {
  return request.post('/admin_user/qy_jy.html',data)
}


// 根据产品名称和产品编码模糊查询
export const productQueryName = (param) => {
  return request.get('/ec/companyproduction/queryByName',param)
}

// 新增产值和产品产量统计
export const productionStatisticsSaveAll = (data) => {
  return request.post('/ec/companyproduction/saveAll', data)
}
// 产值统计 集合查询
export const outputStatisticsList = (data) => {
    return request.post('/ec/companychildoutput/list', qs.stringify(data), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
  }

//获取用能单位能碳值
export const companyPlanEnergyCarbonOfYear = (data) => {
    return request.get('/ec/energyconsumptionraw/companyEnergyCarbonOfYear', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
  }

  // https://hmd.18durensheng.com/
  // 小程序用户信息列表
  export const getUserList = (data) => {
    return request.post('/admin_xcxuser/index.html', data)
  }
  // 修改小程序用户信息https://hmd.18durensheng.com/admin_xcxuser/updataUser.html
  export const editInfo = (data) => {
    return request.post('/admin_xcxuser/updataUser.html', data)
  }


// WEBPACK FOOTER //
// ./src/utils/api.js